export default "__VITE_ASSET__CZh$lODI__"